import { render, staticRenderFns } from "./PreviewModalNew.vue?vue&type=template&id=124da5b4&scoped=true&"
import script from "./PreviewModalNew.vue?vue&type=script&lang=ts&"
export * from "./PreviewModalNew.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewModalNew.vue?vue&type=style&index=0&id=124da5b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124da5b4",
  null
  
)

export default component.exports